<template>
  <section ref="section" class="cn-rich-images-grid">
    <div class="container">
      <div v-if="data?.items?.length" class="cn-rich-images-grid__content">
        <div
          v-for="image in data.items"
          :key="image.src"
          class="image-wrapper"
          :class="[`image-wrapper--cols-${image.cols ?? 1}`]"
        >
          <CdnImg
            :src="image.path"
            class="image"
            :style="{ objectPosition: `center ${image.position}` }"
            format="webp"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { CdnImg } from '@webplatform/cdn-image';
import { ref } from 'vue';

// TODO: fix type
interface Props {
  data: {
    items: any[];
  };
}

defineProps<Props>();

const section = ref(null);
</script>

<style lang="scss">
.cn-rich-images-grid {
  padding-top: var(--size-5xl);
  padding-bottom: var(--size-5xl);
  @media (min-width: 992px) {
    padding-top: var(--size-7xl);
    padding-bottom: var(--size-7xl);
  }
  &__content {
    gap: var(--size-xs);
    grid-template-columns: repeat(4, minmax(0, 1fr));
    display: grid;
    @media (min-width: 992px) {
      gap: var(--size-xl);
    }

    .image-wrapper {
      overflow: hidden;
      height: auto;

      .image {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
      &--cols-1 {
        grid-column: span 2 / span 2;
        @media (min-width: 992px) {
          grid-column: span 1 / span 1;
        }
      }
      &--cols-2 {
        grid-column: span 2 / span 2;
        @media (min-width: 992px) {
          aspect-ratio: 688 / 375;
        }
      }
    }
  }
}
</style>
